import { LitElement, html, css,TemplateResult, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import '../../voyage-popup/src/voyage-popup';
import './voyage-dialog-popup-body-warning';

@customElement('voyage-dialog-popup')
export class VoyageDialogPopup extends LitElement
{
    @property({ type: String, attribute: "header-text" }) headerText: string = "";
    @property({ type: String, attribute: "body-text" }) bodyText: string = "";
    @property({ attribute: false }) bodyContent: TemplateResult | HTMLElement | null = null;
    @property({ type: Boolean, attribute: "is-error" }) isError: boolean = false;
    @property({ type: Boolean, attribute: "align-left" }) alignLeft: boolean = false;
    @property({ type: String }) errorDetails: string = "";
    @property({ type: String, attribute: "accept-button-text" }) acceptButtonText: string = "OK";
    @property({ type: Boolean, attribute: "no-accept-button" }) noAcceptButton: boolean = false;
    @property({ type: String, attribute: "reject-button-text" })  rejectButtonText: string = "";
    @property({ type: Boolean, attribute: "no-close-button" }) noCloseButton: boolean = false;
    @property({ type: String, attribute: "secondary-button-text" }) secondaryButtonText : string = "";
    @property({ type: Boolean, attribute: "no-header-box" }) noHeaderBox: boolean = false;
    @property({ type: String, attribute: "subText" }) subText: string | null = null;


    static get styles() {
        return [
            css`
            :host {
            }

            .main {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .errorIcon {
                margin: 40px;
                margin-top: 25px;
            }

            .errorIcon > svg {
                fill: var(--voyage-error-red, red);
                width: 40px;
            }

            .body {
                margin: 2px 26px 20px;
                color: var(--neutrals-grey-02, black);
                font-family: MaerskText;
                font-size: 14px;
                text-align: left;
                white-space: pre-line;
            }

            .body[is-error] {
                margin-top: 0px;
            }

            .body[is-left-aligned] {
                text-align: left; 
                max-width: 650px; 
                color: #5b5a59;  
                padding-top: 18px;  
             }

            .errorDetails {
                box-sizing: border-box;
                margin: 40px;
                margin-top: 0;
                padding: 20px;
                border: 1px solid var(--warning-yellow-8, yellow);
                border-radius: 3px;
                background-color: rgba(var(--warning-yellow-10-rgb, yellow), 0.63);
                max-width: 635px;
                text-align: center;
                font-family: MaerskText;
                font-size: 14px;
                color: var(--neutrals-grey-02, black);
                white-space: pre-line;
            }

            .subText {
                color: #666;
                margin: 0;
                padding-top: 5px;
                font-size: 10px;
            }
        `];
    }

    render()
    {
        return html`
            <voyage-popup shown header-text=${this.headerText} accept-button-text=${this.acceptButtonText} secondary-button-text=${this.secondaryButtonText} reject-button-text=${this.rejectButtonText} .noCloseButton=${this.noCloseButton} .noAcceptButton=${this.noAcceptButton} .noHeaderBox=${this.noHeaderBox}>
                ${ this.bodyContent ? this.bodyContent : this._defaultContent()}
            </voyage-popup>
        `;
    }

    firstUpdated()
    {
        this._popup = this.shadowRoot!.querySelector('voyage-popup');
        this._popup!.addEventListener('accept', () => this.remove() );
        this._popup!.addEventListener('close', () => this.remove() );
        this._popup!.addEventListener('secondaryAction', () => this.remove() );
    }

    async getResponse(): Promise<"accept"|"reject"|"secondaryAction">
    {
        if (!this._popup)
        {
            await this.updateComplete;
        }

        return new Promise( resolve => {
            this._popup!.addEventListener('accept', () => resolve('accept'), {once: true});
            this._popup!.addEventListener('close', () => resolve('reject'), {once: true});
            this._popup!.addEventListener('secondaryAction', () => resolve('secondaryAction'), {once: true});
        });
    }

    private _popup: HTMLElement|null = null;

    private _defaultContent() {
        return (
            html`
                <div class="main">${ this.isError ? html`<div class="errorIcon">${SvgIcons.lightExclamationTriangle}</div>` : html``}
                    <div class="body" ?is-error=${this.isError} ?is-left-aligned = ${this.alignLeft}>${this.bodyText}
                        <span class="subText">${this.subText ? this.subText : nothing}</span>
                    </div>
                    ${ this.errorDetails ? html`
                        <div class="errorDetails">
                            ${this.errorDetails}
                        </div>
                    `:html``}
                </div>`
        )
    }
}
